import { Outlet } from 'react-router-dom';
import Header from './components/Header/Header.tsx';
import Footer from './components/Footer/Footer.jsx';
import { Box } from '@mui/material';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './components/Analytics/AnalyticsTracker.jsx';
import IdleSignOut from './pages/Authentication/IdleSignOut.jsx';
import './styles/mobidawg-style.scss';

function RootLayout() {
  return (
    <>
      <AnalyticsTracker />
      <IdleSignOut />
      <ScrollToTop />
      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        <Header />
        <Box
          component="main"
          // This Box is the main content area. It's a flex column
          // to allow the footer to be pushed to the bottom.
          sx={{
            flexGrow: 1,
            p: 3,
            mt: '64px', // Push content down to account for the AppBar
            display: 'flex',
            boxSizing: 'border-box', // Include padding in the height calculation
            flexDirection: 'column',
          }}
        >
          {/* This Box wraps the main page content and grows to fill available space */}
          <Box sx={{ flexGrow: 1 }}>
            <Outlet />
          </Box>
          <Footer />
        </Box>
      </Box>
    </>
  );
}
export default RootLayout;
